import { render, staticRenderFns } from "./workloginfo-add-or-update.vue?vue&type=template&id=8e836f3c&scoped=true&"
import script from "./workloginfo-add-or-update.vue?vue&type=script&lang=js&"
export * from "./workloginfo-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./workloginfo-add-or-update.vue?vue&type=style&index=0&id=8e836f3c&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e836f3c",
  null
  
)

export default component.exports